export enum IFrameUrlKey {
  LibraryApps = 'library-apps',
}
